<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="services"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import Service from '@/api/service'
  import input from '@/mixins/input'
  import { mapGetters } from 'vuex'
  export default {
    mixins: [input],
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform'
      }),
      availableServices () {
        const types = Service.OFFER_TYPES
        const disabledTypes = this.platform.settings.disabledOffers || []
        return types.filter(x => !disabledTypes.includes(x))
      },
      services () {
        return this.availableServices.map(e => ({ code: e, name: this.$t(`inputs.servicetype.services.${e}`) }))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/ServiceType.vue